import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getCurrencyListAPI = () => {
  return axiosInstance.request({
    url: `${API.AUCTION}/GetCurrency`,
    method: 'get',
  });
};

export type CurrencyListResponse = {
  code: string; // 'CAD'
  currencyName: string; // 'CANADIAN DOLLAR'
}[];

export const fetchCurrencyList = async (): Promise<CurrencyListResponse> => {
  const response: AxiosResponse<CurrencyListResponse> = await getCurrencyListAPI();
  return response.data;
};
